import axios from "axios";
import { api_path } from "../environment";

import {
  triggerSessionExpired,
  registerController,
  unregisterController,
} from "../helper/sessionManager";

const axiosInstance = axios.create({
  baseURL: api_path.baseURL, // URL de base pour les requêtes
  withCredentials: true, // pour envoyer les cookies automatiquement
});

// =========================
// REQUEST INTERCEPTOR
// =========================

axiosInstance.interceptors.request.use(
  (config) => {
    // creer un controller pour cette requete
    const controller = new AbortController();

    config.signal = controller.signal;

    // stocker le controller
    registerController(controller);

    // sauvegarder pour cleanup plus tard
    config.metadata = { controller };

    return config;
  },
  (error) => Promise.reject(error),
);

// =========================
// RESPONSE INTERCEPTOR
// =========================
axiosInstance.interceptors.response.use(
  (response) => {
    // cleanup controller
    const controller = response.config.metadata?.controller;

    if (controller) {
      unregisterController(controller);
    }

    return response;
  },
  (error) => {
    const { config } = error;

    // cleanup controller
    const controller = config?.metadata?.controller;

    if (controller) {
      unregisterController(controller);
    }

    // ✅ ignorer les requêtes annulées
    if (axios.isCancel(error) || error.code === "ERR_CANCELED") {
      return;
    }

    // requête annulée volontairement
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401) {
      const code = error.response?.data?.code || error.code;

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message;

      const SESSION_ERROR_CODES = [
        "SESSION_EXPIRED",
        "SESSION_INVALID",
        "TOKEN_EXPIRED",
        "TOKEN_INVALID",
        "ACCOUNT_DISABLED",
        "TOKEN_MISSING",
      ];

      if (SESSION_ERROR_CODES.includes(code)) {
        triggerSessionExpired(message, code);
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
